export {PicturePipe} from './picture.pipe';
export {TextPipe} from './text.pipe';
export {TitlePipe} from './title.pipe';
